export const name = 'rnFormat';

export const ROUNDING = {
  floor: 'floor',
  ceil: 'ceil',
  round: 'round',
};

/**
 * @ngdoc service
 * @name rhino.components.locale.format.service:rnFormat
 * @description Provides for formatting strings according to the user's preferred locale
 */
export default function rnFormat(rnLocaleCookie, $window) {
  'ngInject';

  const SI_SUFFIX = ['', 'k', 'M', 'G', 'T', 'P', 'E'];
  const localeCompareOptions = { numeric: true };
  const locale = rnLocaleCookie.getLocale();
  const service = {
    toLocaleString,
    localeOrderBy,
    abbr,
  };
  return service;

  ///////////////

  /**
   * @ngdoc function
   * @name toLocaleString
   * @methodOf rhino.components.locale.format.service:rnFormat
   * @description Formats a number according to the current locale preference
   *
   * @returns {string} number formatted in the preferred locale
   */
  function toLocaleString(num, fractionSize) {
    if(num === undefined) {
      return '';
    }
    if (fractionSize < 0) {
      fractionSize = 0;
    }

    return (+num).toLocaleString(locale, { minimumFractionDigits: 0 , maximumFractionDigits: fractionSize });
  }

  /**
   * @ngdoc function
   * @name localeOrderBy
   * @methodOf rhino.components.locale.format.service:rnFormat
   * @description Uses `String.localeCompare` to order strings so that accented characters
   * are sorted correctly. Adapted from http://www.janholinka.net/Blog/Article/8
   *
   * @returns {string[]} the sorted array
   */
  function localeOrderBy(array, sortPredicate, reverseOrder) {
    if (!Array.isArray(array)) {
      return array;
    }
    if (!sortPredicate) {
      return array;
    }

    const arrayCopy = _.clone(array);

    arrayCopy.sort((a, b) => {
      let valueA = a[sortPredicate];
      let valueB = b[sortPredicate];

      if (_.isString(valueA)) {
        return !reverseOrder ? valueA.localeCompare(valueB, undefined, localeCompareOptions) : valueB.localeCompare(valueA, undefined, localeCompareOptions);
      }

      if (_.isNumber(valueA) || _.isBoolean(valueA)) {
        return !reverseOrder ? (valueA - valueB) : (valueB - valueA);
      }

      return 0;
    });

    return arrayCopy;
  }

  function abbr(num, opts = {}) {
    if ($window.Number.isNaN($window.Number.parseFloat(num))) {
      return num;
    }

    let options = Object.assign({
      fractionSize: 2,
    }, opts);

    let result = num;
    let thousandsPower = 0;
    while (result > 1000) {
      result = result / 1000;
      thousandsPower++;
    }

    let suffix = SI_SUFFIX[thousandsPower];
    if (!suffix) {
      suffix = '';
      result = num;
    }

    return (+result).toLocaleString(locale, opts) + suffix;
  }
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/locale/format/format.service.js